import React, { Component } from "react";
import { isMobile } from "react-device-detect";
import Colors from "../../../assets/Colors";

class CustomToggleButton extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    let { value, title, onClick } = this.props;

    let fakeInputStyle = {
      padding: 1,
      backgroundColor: value ? Colors.main : "#fff",
      border: "1px solid #e1e4e8",
      borderRadius: 50,
      height: 42,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      // width: isMobile ? '100%' : '80%',
      position: "relative",
      marginBottom: 7,
      color: value ? "#fff" : "#a6aebc",
      fontSize: 16,
      cursor: "pointer",
    };

    return (
      <div style={styles.col}>
        <div style={fakeInputStyle} onClick={onClick}>
          {title}
        </div>
      </div>
    );
  }
}

const styles = {
  col: {
    width: "17%",
    minWidth: 160,
    marginLeft: 9,
  },
};

export default CustomToggleButton;
